<template>
  <b-container>
    <b-row>
      <b-col class="px-0">
        <b-card
          v-if="selectedTeam"
          no-body
          class="mt-0">
          <b-card-header header-tag="nav">
            <span style="line-height:38px;">Colors</span>
            <span class="float-right">
              <b-btn
                v-b-toggle.sidebar-1
                href="#"
                variant="outline-primary">
                Options
              </b-btn>
            </span>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row cols="3">
                <b-col
                  v-for="color in config.options.teamColors"
                  :key="color">
                  <form-color-picker
                    v-model="selectedTeam.teamColors[color]"
                    picker="chrome"
                    :label="color" />
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-sidebar
      id="sidebar-1"
      right
      title="Color Options"
      width="275px"
      shadow>
      <b-btn
        v-b-modal.new-color-option
        style="width: 100%;"
        class="my-2"
        variant="primary">
        Add Color
      </b-btn>
      <b-list-group>
        <b-list-group-item
          v-for="(color, idx) in config.options.teamColors"
          :key="idx"
          class="d-flex justify-content-between align-items-center">
          {{ color }}
          <b-img
            title="Delete"
            src="/img/icons/trash-icon.svg"
            class="asset-action-icon mx-2 my-1 my-lg-0"
            @click.stop="deleteColor(color)" />
        </b-list-group-item>
      </b-list-group>
      <b-modal
        id="new-color-option"
        hide-header
        @ok="addColor"
        @show="newColorOption = null">
        <b-form-input
          v-model="newColorOption"
          v-focus
          placeholder="Enter new color..." />
      </b-modal>
    </b-sidebar>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex"
import FormColorPicker from "@/components/FormColorPicker"

export default {
  name: "TeamColorsForm",
  components: {
    FormColorPicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    selectedTeam: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    newColorOption: null,
  }),
  computed: {
    ...mapGetters([
      "canBrandingEdit",
    ]),
    config: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
    isDisabled() {
      return !this.canBrandingEdit
    },
  },
  methods: {
    async deleteColor(color) {
      const modalConfirmed = await this.$confirm.open(`Deleting a color affects all teams. Are you sure you want to delete [${color}] from all teams?`)
      if (!modalConfirmed) {
        return
      }

      // remove the color from the options
      const index = this.config.options.teamColors.indexOf(color)
      if (index > -1) {
        this.config.options.teamColors.splice(index, 1)
      }

      // remove the color from all team fields
      delete (this.config.mlb[color])
      this.config.allstarTeams.forEach(t => delete (t[color]))
      this.config.teams.forEach(t => delete (t[color]))
    },
    addColor() {
      this.config.options.teamColors.push(this.newColorOption)
    },
  },
}
</script>

<style scoped>

.card {
  margin: 1.5rem 0;
}

.asset-action-icon {
  cursor: pointer;
  max-height: 16px;
  max-width: 16px;
}

</style>
